import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger"]

  closeOnOutsideClick(event) {
    if (this.element.open && !this.element.contains(event.target)) {
      this.element.open = false
    }
  }

  closeOnEscape(event) {
    if (!this.element.open) return

    event.preventDefault()
    this.element.open = false
    this.triggerTarget.focus()
  }
}
